import {
    Grid,
    Typography,
    AppBar,
    Toolbar,
} from "@mui/material";
import { useParams } from 'react-router-dom';
import { useMatch } from "../../hooks/useMatch";
import { auth, db } from "../../config/firebase";
import MatchPlayer from "../../components/MatchPlayer";
import MatchSolveTable from "../../components/MatchSolveTable";
import { usePlayerMatch } from "../../hooks/usePlayerMatch";
import React from "react";

const Match = () => {
    const { id } = useParams();
    const { match, loading, error } = useMatch(db, id);
    
    const currentPlayer = React.useMemo(() => {
        if (match && auth.currentUser) {
          const player = match.uids.find((p) => p === auth.currentUser?.uid);
          return player ? player : null;
        }
        return null;
      }, [match, auth.currentUser]);
    
      const opponent = React.useMemo(() => {
        if (match && auth.currentUser) {
          const player = match.uids.find((p) => p !== auth.currentUser?.uid);
          return player ? player : null;
        }
        return null;
      }, [match, auth.currentUser]);
    
    // Determine if the logged-in user is a player
    //const currentPlayer = match.uids.find((p) => p === auth.currentUser?.uid);
    //const opponent = match.uids.find((p) => p !== auth.currentUser?.uid);

    const { player: playerP, roundSolves: roundSolvesP, loading: loadingP, error: eerorP } = usePlayerMatch(db, id!, currentPlayer);
    const { player: playerO, roundSolves: roundSolvesO, loading: loadingO, error: eerorO } = usePlayerMatch(db, id!, opponent);

    if (!currentPlayer) return <p>You are not a player in this match.</p>;
    if (error) return <p>Error: {error.message}</p>;
    if (!match) return <p>Match not found.</p>;
    if (!auth.currentUser) return <p>You need to be logged in to view this match.</p>;

    
    return (<div style={{ display: 'flex', flexDirection: 'column', height: '100vh' }}>
        <AppBar position="static" color='secondary'>
            <Toolbar>
                <Typography variant="h6" sx={{ flexGrow: 1 }}>
                    Match {id}
                </Typography>
            </Toolbar>
        </AppBar>

        {!loading && match !== null && playerP !== null && playerO !== null && <Grid container spacing={2} sx={{ padding: 2, flexGrow: 1, overflowY: 'auto', alignContent: 'flex-start' }}>
            <Grid key={currentPlayer} item xs={12}>
                <MatchPlayer 
                    playerId={currentPlayer} 
                    matchId={id!} 
                    roundNumber={match.currentRound} 
                    solveNumber={match.currentSolve}
                    streamid={match.streamids[match.uids.indexOf(currentPlayer)]}
                />
            </Grid>
                <MatchSolveTable 
                    playerSolves={{player: playerP, roundSolves: roundSolvesP}}
                    opponentSolves={{player: playerO, roundSolves: roundSolvesO}}
                    currentRound={match.currentRound}
                    currentSolve={match.currentSolve}
                />
            
            {opponent && 
                <MatchSolveTable 
                    opponentSolves={{player: playerP, roundSolves: roundSolvesP}}
                    playerSolves={{player: playerO, roundSolves: roundSolvesO}}
                    currentRound={match.currentRound}
                    currentSolve={match.currentSolve}
                />
            }
        </Grid>}

    </div>
    );
};

export default Match;
